export { default as EditText } from "./edit-text.vue";
export * from "./IEditText";